import React, {useState, useEffect} from 'react';
import {X} from 'lucide-react';
import styles from './BrandsList.module.css';
import useApi from "../../utils/useApi";
import {useGeolocation} from "../../contexts/GeolocationProvider";
import {NavVisibilityProvider} from "../NavVisibilityContext/NavVisibilityContext";

const BrandsList = ({ isVisible, setIsVisible, onClose, distance, onSelectBrand, onSale, category, businessId }) => {
    const [brands, setBrands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentCategory, setCurrentCategory] = useState(null);
    const [currentDistance, setCurrentDistance] = useState(null);
    const [currentOnSale, setCurrentOnSale] = useState(null);
    const { geoposition } = useGeolocation();
    const { isNavVisible, setIsNavVisible } = NavVisibilityProvider;
    const api = useApi();

    useEffect(() => {
        fetchBrands();
    }, [isVisible]);

    useEffect(() => {
        fetchBrands();
    }, [category, distance, onSale]);

    const fetchBrands = async () => {
        console.log('getting brands');
        if (category !== currentCategory || distance !== currentDistance || currentOnSale !== onSale) {
            setIsLoading(true);
            setCurrentCategory(category);
            setCurrentDistance(distance);
            setCurrentOnSale(onSale);
            try {
                const query = {
                    geoposition: geoposition,
                    distance: distance,
                    onSale: onSale,
                    category: category,
                    businessId: businessId,
                }
                console.log(query);
                const response = await api.getBrandsArea(query);
                setBrands(response.data);
            }
            catch (error) {
                console.error('Error fetching brands:', error);
            }
            finally {
                setIsLoading(false);
            }
        }
    };

    const filteredBrands = brands.filter(brand =>
                                             brand.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // Handle touch move to prevent underlying content scrolling
    const handleTouchMove = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleSelectBrand = (brandId) => {
        onSelectBrand(brandId);
        setIsVisible(false);
        document.body.style.overflowY = "auto";
        document.getElementById('MainApp').style.overflowY = "auto";
        document.getElementById('root').style.overflowY = "auto";
    }

    return (
        <div
            className={`${styles.brandsListContainer} ${isVisible ? styles.visible : ''}`}
            onTouchMove={handleTouchMove}
        >
            <div className={`absolute w-full h-full`}>
                <div className={styles.header}>
                    <h2 className={`flex items-center gap-1`}>Brands {onSale > 0 && (
                        <span className={`text-xs`}>(On Sale)</span>
                    )}</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        <X className={styles.closeIcon}/>
                    </button>
                </div>

                <div className={styles.searchContainer}>
                    <input
                        type="text"
                        placeholder="Search brands..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>

                <div className={styles.brandsContent}>
                    {isLoading ? (
                        <div className={styles.loadingState}>Loading brands...</div>
                    ) : (
                         <>
                             {filteredBrands.length > 0 ? (
                                 <ul className={styles.brandsList}>
                                     {filteredBrands.map((brand) => (
                                         <li key={brand.id} className={styles.brandItem} onClick={() => handleSelectBrand(brand)}>
                                             <div className={styles.logoContainer}>
                                                 {brand.logo ? (
                                                     <img
                                                         src={brand.logo}
                                                         alt={`${brand.name} logo`}
                                                         className={styles.brandLogo}
                                                         onError={(e) => {
                                                             e.target.onerror = null;
                                                             e.target.src = "https://leafly-public.imgix.net/brands/brand-placeholder.svg";
                                                         }}
                                                     />
                                                 ) : (
                                                      <div className={styles.placeholderLogo}>
                                                          {brand.name.charAt(0)}
                                                      </div>
                                                  )}
                                             </div>
                                             <span className={styles.brandName}>{brand.name}</span>
                                         </li>
                                     ))}
                                 </ul>
                             ) : (
                                  <div className={styles.emptyState}>
                                      {(searchTerm && !onSale)&& ('No brands match your search')}
                                      {(!searchTerm && onSale) && ( 'No brands on sale today')}
                                      {(searchTerm && onSale) && ( 'No brands match your search that are on sale today')}
                                  </div>
                              )}
                         </>
                     )}
                </div>
            </div>

        </div>
    );
};

export default BrandsList;
